import { gql } from '@apollo/client';

export const TAXONOMY_FIELDS_FRAGMENT = gql`
  fragment TaxonomyFields on TaxonomyFunctionType {
    id
    name
    office
    taxonomy {
      industry {
        id
      }
    }
  }
`;
